import React from 'react';

const fish = (
  <svg viewBox="0 0 746 296">
    <g>
      <circle cx="374" cy="205" r="4" />
      <circle cx="393" cy="72" r="4" />
      <circle cx="393" cy="186" r="4" />
      <circle cx="393" cy="148" r="4" />
      <circle cx="374" cy="167" r="4" />
      <circle cx="393" cy="110" r="4" />
      <circle cx="374" cy="243" r="4" />
      <circle cx="355" cy="186" r="4" />
      <circle cx="374" cy="129" r="4" />
      <circle cx="355" cy="148" r="4" />
      <circle cx="374" cy="91" r="4" />
      <circle cx="374" cy="53" r="4" />
      <circle cx="355" cy="224" r="4" />
      <circle cx="716" cy="243" r="4" />
      <path d="M713.1,55.8l-0.6-4.3c-0.1,0-0.1,0-0.2,0c-0.2,0.5-0.3,1-0.3,1.5C712,54.1,712.4,55,713.1,55.8z" />
      <path d="M736.2,220.2c-0.4-0.1-0.8-0.2-1.2-0.2c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c0.8,0,1.6-0.2,2.2-0.7L736.2,220.2z" />
      <path d="M716,87c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c1,0,1.8-0.3,2.5-0.9l-1-6.8C717.1,87.1,716.6,87,716,87z" />
      <path
        d="M450,277c-2.2,0-4,1.8-4,4c0,0.1,0,0.1,0,0.2c2.5,0.4,5.1,0.9,7.7,1.3c0.2-0.5,0.3-1,0.3-1.5C454,278.8,452.2,277,450,277z
    "
      />
      <circle cx="716" cy="129" r="4" />
      <circle cx="412" cy="129" r="4" />
      <circle cx="412" cy="91" r="4" />
      <circle cx="716" cy="205" r="4" />
      <circle cx="393" cy="262" r="4" />
      <circle cx="393" cy="224" r="4" />
      <circle cx="412" cy="167" r="4" />
      <circle cx="412" cy="243" r="4" />
      <circle cx="412" cy="205" r="4" />
      <circle cx="298" cy="91" r="4" />
      <circle cx="298" cy="53" r="4" />
      <circle cx="279" cy="148" r="4" />
      <circle cx="279" cy="186" r="4" />
      <circle cx="298" cy="129" r="4" />
      <circle cx="298" cy="167" r="4" />
      <circle cx="298" cy="205" r="4" />
      <circle cx="260" cy="167" r="4" />
      <circle cx="260" cy="205" r="4" />
      <circle cx="260" cy="129" r="4" />
      <circle cx="279" cy="34" r="4" />
      <circle cx="355" cy="110" r="4" />
      <circle cx="279" cy="72" r="4" />
      <circle cx="279" cy="110" r="4" />
      <circle cx="336" cy="129" r="4" />
      <circle cx="336" cy="91" r="4" />
      <circle cx="317" cy="34" r="4" />
      <path d="M355,38c1.1,0,2.1-0.5,2.9-1.2c-2.2-0.7-4.5-1.4-6.8-2.1C351.4,36.6,353,38,355,38z" />
      <circle cx="336" cy="53" r="4" />
      <circle cx="355" cy="72" r="4" />
      <circle cx="336" cy="205" r="4" />
      <circle cx="317" cy="186" r="4" />
      <circle cx="260" cy="91" r="4" />
      <circle cx="317" cy="72" r="4" />
      <circle cx="317" cy="148" r="4" />
      <circle cx="317" cy="224" r="4" />
      <circle cx="317" cy="110" r="4" />
      <circle cx="602" cy="91" r="4" />
      <circle cx="583" cy="224" r="4" />
      <circle cx="602" cy="129" r="4" />
      <circle cx="602" cy="167" r="4" />
      <circle cx="602" cy="205" r="4" />
      <circle cx="583" cy="262" r="4" />
      <circle cx="564" cy="281" r="4" />
      <circle cx="602" cy="281" r="4" />
      <circle cx="564" cy="205" r="4" />
      <circle cx="564" cy="243" r="4" />
      <circle cx="583" cy="186" r="4" />
      <circle cx="583" cy="110" r="4" />
      <circle cx="583" cy="148" r="4" />
      <circle cx="602" cy="243" r="4" />
      <circle cx="640" cy="167" r="4" />
      <circle cx="564" cy="167" r="4" />
      <circle cx="640" cy="91" r="4" />
      <circle cx="640" cy="129" r="4" />
      <circle cx="640" cy="243" r="4" />
      <circle cx="640" cy="205" r="4" />
      <circle cx="621" cy="224" r="4" />
      <circle cx="621" cy="110" r="4" />
      <circle cx="621" cy="262" r="4" />
      <path d="M624.4,74c-1.8,0.5-3.6,1-5.4,1.5c0.6,0.3,1.3,0.5,2,0.5C622.5,76,623.8,75.2,624.4,74z" />
      <circle cx="621" cy="186" r="4" />
      <circle cx="621" cy="148" r="4" />
      <circle cx="659" cy="148" r="4" />
      <circle cx="659" cy="262" r="4" />
      <circle cx="678" cy="205" r="4" />
      <circle cx="678" cy="243" r="4" />
      <path
        d="M697,258c-2.2,0-4,1.8-4,4c0,1.6,0.9,2.9,2.2,3.6c1.8-0.5,3.5-1,5.2-1.6c0.3-0.6,0.6-1.3,0.6-2
    C701,259.8,699.2,258,697,258z"
      />
      <circle cx="678" cy="91" r="4" />
      <circle cx="678" cy="129" r="4" />
      <circle cx="678" cy="167" r="4" />
      <circle cx="697" cy="224" r="4" />
      <circle cx="697" cy="72" r="4" />
      <circle cx="697" cy="148" r="4" />
      <path d="M731.7,188.3l-0.5-3.6c-0.1,0.4-0.2,0.8-0.2,1.3C731,186.9,731.3,187.7,731.7,188.3z" />
      <circle cx="697" cy="110" r="4" />
      <circle cx="697" cy="186" r="4" />
      <circle cx="545" cy="110" r="4" />
      <circle cx="545" cy="224" r="4" />
      <circle cx="545" cy="148" r="4" />
      <circle cx="564" cy="129" r="4" />
      <circle cx="564" cy="91" r="4" />
      <circle cx="545" cy="262" r="4" />
      <circle cx="545" cy="186" r="4" />
      <circle cx="659" cy="186" r="4" />
      <path d="M640,277c-2,0-3.6,1.5-3.9,3.3c2.5-0.5,4.9-0.9,7.3-1.4C642.7,277.8,641.4,277,640,277z" />
      <circle cx="659" cy="224" r="4" />
      <circle cx="716" cy="167" r="4" />
      <circle cx="659" cy="72" r="4" />
      <circle cx="659" cy="110" r="4" />
      <circle cx="336" cy="167" r="4" />
      <circle cx="13" cy="72" r="4" />
      <circle cx="127" cy="186" r="4" />
      <circle cx="127" cy="224" r="4" />
      <circle cx="146" cy="53" r="4" />
      <circle cx="146" cy="129" r="4" />
      <circle cx="146" cy="91" r="4" />
      <circle cx="108" cy="205" r="4" />
      <circle cx="127" cy="34" r="4" />
      <circle cx="127" cy="148" r="4" />
      <circle cx="146" cy="205" r="4" />
      <circle cx="108" cy="167" r="4" />
      <circle cx="127" cy="110" r="4" />
      <circle cx="127" cy="72" r="4" />
      <path d="M32,247c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4c-0.5,0-1,0.1-1.5,0.3l1.1,7.7C31.7,247,31.8,247,32,247z" />
      <circle cx="184" cy="205" r="4" />
      <circle cx="184" cy="167" r="4" />
      <circle cx="184" cy="129" r="4" />
      <circle cx="108" cy="129" r="4" />
      <path d="M17,110c0-2.2-1.8-4-4-4c-0.4,0-0.7,0.1-1.1,0.2L13,114C15.2,114,17,112.2,17,110z" />
      <circle cx="260" cy="53" r="4" />
      <circle cx="165" cy="148" r="4" />
      <circle cx="165" cy="110" r="4" />
      <circle cx="165" cy="72" r="4" />
      <circle cx="165" cy="34" r="4" />
      <circle cx="184" cy="53" r="4" />
      <circle cx="146" cy="167" r="4" />
      <circle cx="165" cy="186" r="4" />
      <path d="M147.5,18.7c-0.6,0.1-1.3,0.2-1.9,0.2c0.1,0,0.3,0,0.4,0C146.5,19,147,18.9,147.5,18.7z" />
      <circle cx="51" cy="72" r="4" />
      <circle cx="70" cy="53" r="4" />
      <path d="M165,220c-1.8,0-3.2,1.1-3.8,2.7c2.3-0.4,4.6-0.8,6.9-1.2C167.4,220.6,166.3,220,165,220z" />
      <circle cx="51" cy="110" r="4" />
      <circle cx="51" cy="186" r="4" />
      <circle cx="51" cy="148" r="4" />
      <circle cx="51" cy="224" r="4" />
      <circle cx="203" cy="110" r="4" />
      <path d="M184,19c2.1,0,3.8-1.6,4-3.6c-2.7,0.1-5.3,0.2-7.9,0.4C180.4,17.6,182,19,184,19z" />
      <circle cx="203" cy="186" r="4" />
      <circle cx="203" cy="34" r="4" />
      <circle cx="203" cy="72" r="4" />
      <circle cx="203" cy="148" r="4" />
      <circle cx="108" cy="53" r="4" />
      <circle cx="89" cy="186" r="4" />
      <circle cx="89" cy="224" r="4" />
      <circle cx="89" cy="148" r="4" />
      <circle cx="89" cy="110" r="4" />
      <circle cx="108" cy="91" r="4" />
      <path d="M89,38c2.2,0,4-1.8,4-4c0-1.8-1.2-3.3-2.9-3.8c-1.4,0.4-2.7,0.7-4,1.1C85.4,32,85,33,85,34C85,36.2,86.8,38,89,38z" />
      <circle cx="70" cy="205" r="4" />
      <circle cx="70" cy="129" r="4" />
      <circle cx="70" cy="167" r="4" />
      <circle cx="89" cy="72" r="4" />
      <circle cx="70" cy="243" r="4" />
      <circle cx="70" cy="91" r="4" />
      <circle cx="184" cy="91" r="4" />
      <circle cx="431" cy="110" r="4" />
      <circle cx="431" cy="186" r="4" />
      <circle cx="431" cy="148" r="4" />
      <circle cx="431" cy="72" r="4" />
      <path
        d="M340,243c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4c0,0.8,0.2,1.5,0.6,2.2c0.5,0.2,1.1,0.5,1.6,0.7c0.8,0.4,1.7,0.7,2.5,1.1
    C338.6,246.5,340,244.9,340,243z"
      />
      <path
        d="M279,220c-2.2,0-4,1.8-4,4c0,0.4,0.1,0.8,0.2,1.2c2.3,0.5,4.5,1,6.7,1.6c0.7-0.7,1.1-1.7,1.1-2.8
    C283,221.8,281.2,220,279,220z"
      />
      <circle cx="431" cy="262" r="4" />
      <circle cx="450" cy="167" r="4" />
      <circle cx="450" cy="205" r="4" />
      <circle cx="450" cy="91" r="4" />
      <circle cx="431" cy="224" r="4" />
      <circle cx="450" cy="129" r="4" />
      <path d="M240.7,220c0.4,0,0.8,0.1,1.2,0.1c-0.3-0.1-0.6-0.1-1-0.1C240.9,220,240.8,220,240.7,220z" />
      <circle cx="222" cy="167" r="4" />
      <circle cx="241" cy="186" r="4" />
      <circle cx="241" cy="110" r="4" />
      <circle cx="32" cy="91" r="4" />
      <circle cx="241" cy="72" r="4" />
      <circle cx="241" cy="148" r="4" />
      <path d="M260,19c1.2,0,2.3-0.6,3.1-1.5c-2.2-0.2-4.3-0.4-6.5-0.6C257.2,18.2,258.5,19,260,19z" />
      <circle cx="222" cy="129" r="4" />
      <circle cx="222" cy="205" r="4" />
      <circle cx="222" cy="53" r="4" />
      <path d="M222,19c2.1,0,3.8-1.7,4-3.7c-2.6-0.1-5.3-0.1-8-0.2C218.1,17.3,219.8,19,222,19z" />
      <circle cx="450" cy="243" r="4" />
      <circle cx="222" cy="91" r="4" />
      <circle cx="241" cy="34" r="4" />
      <circle cx="526" cy="243" r="4" />
      <circle cx="526" cy="205" r="4" />
      <circle cx="526" cy="167" r="4" />
      <circle cx="469" cy="148" r="4" />
      <circle cx="507" cy="262" r="4" />
      <circle cx="507" cy="224" r="4" />
      <circle cx="526" cy="281" r="4" />
      <circle cx="32" cy="205" r="4" />
      <circle cx="507" cy="186" r="4" />
      <circle cx="32" cy="129" r="4" />
      <circle cx="32" cy="167" r="4" />
      <circle cx="526" cy="91" r="4" />
      <path d="M32,57c2.2,0,4-1.8,4-4c0-1.9-1.4-3.5-3.2-3.9c-1.3,0.5-2.7,1-3.9,1.4C28.3,51.2,28,52.1,28,53C28,55.2,29.8,57,32,57z" />
      <circle cx="526" cy="129" r="4" />
      <circle cx="469" cy="262" r="4" />
      <circle cx="488" cy="129" r="4" />
      <circle cx="469" cy="224" r="4" />
      <circle cx="469" cy="110" r="4" />
      <circle cx="469" cy="186" r="4" />
      <circle cx="488" cy="91" r="4" />
      <circle cx="488" cy="243" r="4" />
      <circle cx="507" cy="148" r="4" />
      <circle cx="488" cy="167" r="4" />
      <circle cx="488" cy="281" r="4" />
      <circle cx="507" cy="110" r="4" />
      <circle cx="488" cy="205" r="4" />
    </g>
  </svg>
);
export default fish;



// WEBPACK FOOTER //
// ./src/components/commons/Pattern/Fish/index.js